import React from "react";
import ProductCategory from "../../productcategory2";
import SEO from "../../seo";

export default function PatentSeriesPage() {
  const data = {
    categoryName: "Patent Series Mattress",
    description:
      "Patent Series by Eclipse is the culmination of years of research and development. Each mattress is constructed using the finest materials combined with pioneering technologies to deliver long lasting comfort and rest. Each patented technology is proven to target specific concerns for immediate improvement in sleep quality.",
    benefits: [
      "Latest luxury bedding technologies",
      "Handcrafted mattresses of the highest quality",
      "Doctor recommended scientific solutions",
      "10 year warranty",
      "Personalized support & customized comfort",
    ],
    products: [
      {
        img: "https://eclipsemattress.in/wp-content/uploads/2019/12/Coil-on-Coil-1.png",
        name: "COIL ON COIL",
        link: "/patent-series-mattress/coil-on-coil/",
        startingAt: "₹1,37,599",
      },
      {
        img: "https://eclipsemattress.in/wp-content/uploads/2019/12/Tiara-Cool-1.png",
        name: "TIARA COOL",
        link: "/patent-series-mattress/tiara-cool/",
        startingAt: "₹86,899",
      },
      {
        img: "https://eclipsemattress.in/wp-content/uploads/2019/12/Accolade.png",
        name: "ACCOLADE PT",
        link: "/patent-series-mattress/accolade-pt/",
        startingAt: "₹40,599",
      },
      {
        img: "https://eclipsemattress.in/wp-content/uploads/2019/12/Romance-1.png",
        name: "ROMANCE",
        link: "/patent-series-mattress/romance/",
        startingAt: "₹38,299",
      },
      {
        img: "https://eclipsemattress.in/wp-content/uploads/2019/12/Oslo-Plush12.png",
        name: "HEALTHSENSE ET",
        link: "/patent-series-mattress/healthsense-et/",
        startingAt: "₹38,299",
      },
      {
        img: "https://eclipsemattress.in/wp-content/uploads/2021/06/Viena-1000X676.png",
        name: "VIENNA ET",
        link: "/patent-series-mattress/vienna-et/",
        startingAt: "₹35,699",
      },
    ],
    brochureLink:
      "https://eclipsemattress.in/assets/pdfs/Patent-&-Luxury-Catalogue.pdf",
    actionToAccess: true,
    banner: "https://eclipsemattress.in/assets/images/banners/patent-d.jpg",
    bannerSm: "https://eclipsemattress.in/assets/images/banners/patent-m.jpg",
    // pattern: patterntest,
    // color: "#EAF3F8",
  };
  return (
    <div>
      <SEO
        title="Patent Series Mattress | Eclipse International"
        description="Years of R&D have culminated in a signature series of exclusive mattresses with advanced technologies and the finest materials.  "
        img="https://eclipsemattress.in/assets/linkpreviews/category/patent-mattress.jpg"
      />
      <ProductCategory category={data} />
    </div>
  );
}
